<template>
  <div v-loading="dataLoading" class="accountJumio-supplement" @click.stop="closeItemshow()">
    <div class="box">
      <rhcn-drawer :showClose="false" :showLogo="false" :jumio="true">
        <template slot="leftTitle">
          <span @click="onBack()" class="leftTitle">
            {{ $t('message.jumio.leftTitle') }}
          </span>
        </template>
        <template slot="headerRight">
          <div class="header-right" v-if="!isView">
            <el-button class="primary-btn" size="small" type="default" @click="submitAudit()">{{
              $t("message.common.submit") }}</el-button>
          </div>
        </template>
        <div class="text-wrapper">
          <h1 class="title">{{ $t('message.jumio.leftTitle') }}</h1>
          <div class="tip margin-top-16">
            <p class="tip-p" v-html="$t('message.jumio.subTitle')"></p>
          </div>
          <div class="errBox" v-if="errBoxShow">
            <div class="errImg">
              <img src="@/assets/images/err.png" alt="">
            </div>
            <div style="margin-left: 10px;">
              <div class="errTitle">{{
                $t("message.jumio.errTitle") }}</div>
              <div class="errMes">{{ errBoxMsg }}</div>
            </div>
          </div>
          <div class="add">
            <el-button class="primary-btn" size="small" type="default" @click="addPopdata()" v-if="!isView && addShow">+
              {{
                $t("message.jumio.add")
              }}</el-button>
          </div>
        </div>

        <div class="drawer-form">
          <!-- 业务描述 -->
          <div class="jumio-wrapper" v-for="(item, index) in jumioData" :key="index">
            <div class="jumio-header">
              <div>
                <span class="jumio-name">{{ item.ownerName }}</span>
                <span v-if="item.faceAuthStatus == '0'" class="status statusP">{{ $t("message.jumio.status.pending")
                  }}</span>
                <span v-if="item.faceAuthStatus == '2'" class="status statusA">{{ $t("message.jumio.status.approved")
                  }}</span>
                <span v-if="item.faceAuthStatus == '3'" class="status statusR">{{ $t("message.jumio.status.rejected")
                  }}</span>
                <span v-if="item.faceAuthStatus == '1'" class="status statusS">{{
                  $t("message.jumio.status.pending_scan")
                }}</span>
              </div>
              <div class="more" v-if="!isView" @click.stop="toggleMore(index)">
                <i class="el-icon-more"></i>
                <div class="morebox" v-if="item.showMore">
                  <div @click="editForm(item)">{{ $t("message.tableCommon.edit") }}</div>
                  <div @click="deleJumio(item)">{{ $t("message.tableCommon.delete") }}</div>
                </div>
              </div>
            </div>
            <div class="type">
              <span v-if="item.ownerRole == 1">{{ $t("message.user.shareholder") }}</span>
              <span v-if="item.ownerRole == 2">{{ $t("message.user.beneficiary") }}</span>
              <span v-if="item.ownerRole == 3">{{ $t("message.user.shareholder") }},{{ $t("message.user.beneficiary")
                }}</span>

            </div>
            <div class="jumio-btn" v-if="!item.authSuccessTime">
              <div class="jumio-email" @click="emailAuth(item)">
                {{ $t("message.jumio.email") }}
              </div>
              <div class="jumio-im" @click="immediately(item)">
                {{ $t("message.jumio.immediately") }}
              </div>
            </div>
            <div class="time" v-if="item.authSuccessTime">
              <span class="time1">{{ $t("message.jumio.authenticated") }}</span>
              <span class="time2">{{ item.authSuccessTime ? item.authSuccessTime.split(' ')[0] : '' }}</span>
            </div>

          </div>
          <!-- 附件上传 -->

          <!-- 受益人 -->
        </div>
      </rhcn-drawer>
    </div>
    <!-- 添加弹窗 -->
    <popModal :title='popTitle' :subTitle='$t("message.jumio.addSubTitle")' :Cancel='$t("message.tableCommon.cancel")'
      :modalWidth="400" :Submit='subword' @closePop="closePop" v-if="addPop" @cancel="cancel" @save="save">
      <template slot="mainContent">
        <div class="mainContent">
          <el-form ref="basicFormRef" :model="addData" :label-position="'top'" :rules="rules">
            <el-form-item :label='$t("message.permission.name")' prop="ownerName">
              <el-input v-model="addData.ownerName"></el-input>
            </el-form-item>
            <el-form-item :label='$t("message.permission.role")' prop="ownerRole">
              <el-checkbox-group v-model="addData.ownerRole">
                <el-checkbox label="1" :disabled="Directordisabled">{{ $t("message.user.shareholder") }}</el-checkbox>
                <el-checkbox label="2" :disabled="Beneficialdis">{{ $t("message.user.beneficiary") }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </popModal>
    <!-- 人脸认证弹窗 -->
    <popModal :title='$t("message.jumio.immediately")' :modalWidth="751" @closePop="closePop" v-if="jumioPop">
      <template slot="mainContent">
        <div class="mainContent jumioPopContent">
          <div class="jumionContent">
            <div>
              <p class="jumionTitle">{{ $t("message.jumio.jumioPopTitle") }}</p>
              <p class="jumionTime" v-html='$t("message.jumio.jumioTime", { time: immediatelyData.expireTime })'></p>
            </div>
            <div class="jumionTips">
              <div>
                <img src="@/assets/images/tips.png" alt="" class="tips"> {{ $t("message.jumio.jumioTips") }}
              </div>
              <div class="content1">{{ $t("message.jumio.jumioTipsContent") }}</div>
              <div class="content2">{{ $t("message.jumio.jumioTipsContent2") }}</div>
            </div>
          </div>
          <div class="jumionImg">
            <img :src="immediatelyData.url" alt="">
          </div>
        </div>
      </template>
    </popModal>
    <!-- 邮件认证弹窗 -->
    <popModal :title='$t("message.jumio.email")' :modalWidth="751" @closePop="closePop"
      :Submit='$t("message.common.send")' @save="emailIm()" v-if="emailPop">
      <template slot="mainContent">
        <div class="mainContent ">
          <div class="emailWarn" v-if="emailData.sendTime">
            <img src="@/assets/images/warn.png" alt="" class="warnImg">
            <span>{{ $t("message.jumio.emailWarn", { time: this.emailData.sendTime, email: this.emailData.exEmail })
              }}</span>
          </div>
          <div class="jumionContent">
            <div>
              <p class="jumionTitle">{{ $t("message.jumio.emailPoptitle") }}</p>
            </div>
          </div>
          <div class="emialContent">
            <p class="emailTitle">{{ emailData.ownerName }}</p>
            <p class="emailRole">{{ emailData.ownerRole }}</p>
            <el-form ref="emailRef" :model="emailData" :label-position="'top'" :rules="emailRules">
              <el-form-item :label='$t("message.jumio.emailLabel")' prop="email">
                <el-input v-model="emailData.email"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
    </popModal>
    <custom-message ref="customMessage"></custom-message>

  </div>
</template>
<script>
import QRcode from 'qrcode';
import { mapGetters } from 'vuex';

import { queryRegisterCountry } from '@/api/common/index';
import { addShareholderInfo, queryShareholderInfo, deleteShareholderInfo, editShareholderInfo, startAuth, submitAudit, queryEmailSendRecord } from '@/api/common/jumio';
import { PHONE_AREAS } from '@/api/common/phone-area.js';
import {
  getUserInformation, updateMerchantInformation, getPhoneCaptcha,
  postCacheImproveInformation, queryCacheImproveInformation,
  addMerchantInformation, getMerchantAudit,
} from '@/api/common/user';
import RhcnDrawer from '@/components/drawer/index.vue';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowWarningMessage, ShowSuccessMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips';
import popModal from '@/components/popModal/index.vue';
import { validateFns, REQUIRED, EMAIL } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import GlobalData from '@/utils/global/index';
import { initSelectedData } from '@/utils/tools/constant';
import { getFileNameFromUrl, shallowClones } from '@/utils/tools/utils';
import AccountInfo from '@/views/account/information/api/account-info';
import RhcnUpload from '@/views/account/information/supplement/upload-v2/index.vue';

export default {
  components: {
    RhcnDrawer,
    popModal,
    CustomMessage,
  },
  data() {
    return {
      type: 'add',
      dataLoading: false,
      isView: false,
      showMore: false,
      errBoxShow: false,
      errBoxMsg: '',
      subword: '',
      addShow: true,
      addData: {
        ownerName: '',
        ownerRole: [],
      },
      popTitle: '',
      popSubTitle: '',
      addPop: false,
      jumioPop: false,
      emailPop: false,
      rules: {
        ownerName: [
          { required: true, message: this.$t('message.validator.required'), trigger: 'blur' },
        ],
        ownerRole: [
          { type: 'array', required: true, message: this.$t('message.validator.required'), trigger: 'change' },
        ],
      },
      emailRules: {
        email: [
          { validator: validateFns([EMAIL]) },
        ],
      },
      jumioData: null,
      immediatelyData: {
        url: '',
        expireTime: '',
      },
      emailData: {
        id: '',
        ownerName: '',
        ownerRole: '',
      },
      Directordisabled: false,
      Beneficialdis: false,

    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    businessType() {
      return this.$route.query?.businessType;
    },
  },
  mounted() {
    console.log(this.$route.query);
    if (this.$route.query?.type === 'view') {
      this.isView = true;
    } else {
      this.isView = false;
    }
    this.initMethods();
    console.log('businessType', this.businessType);
  },
  methods: {

    async emailIm() {
      try {
        // 使用 await 和 Promise 包装 validate 方法以确保它是异步的
        const valid = await new Promise((resolve) => {
          this.$refs.emailRef.validate(resolve);
        });

        if (valid) {
          console.log(this.emailData);
          const params = {
            id: this.emailData.id,
            email: this.emailData.email,
            authMethod: 1,
          };
          console.log('params', params);
          const res = await startAuth(params);
          console.log('res', res);
          ShowSuccessMessage(this.$t('message.jumio.emailSendSuccess'));
          this.emailPop = false;
          this.initMethods();
        } else {
        }
      } catch (error) {
        ShowErrorMessage(error);

        // 可以根据需要显示错误信息给用户
      }
    },
    onBack() {
      console.log('businessType', this.businessType);
      if (this.businessType && this.businessType === 'payout') {
        this.$router.replace({
          path: '/index/aggregate/payout',
        });
      } else {
        this.$router.replace({
          path: '/index',
        });
      }
    },
    toggleMore(index) {
      this.jumioData[index].showMore = !this.jumioData[index].showMore;
      this.jumioData.forEach((item, idx) => {
        if (idx !== index) {
          item.showMore = false;
        }
      });
      console.log('this.jumioData', this.jumioData);
      this.$forceUpdate();
    },
    // 初始化接口
    async initMethods() {
      this.addPop = false;
      const res = await queryShareholderInfo();
      if (res) {
        this.jumioData = res;
        this.jumioData.forEach(item => {
          item.showMore = false;
        });
      }
      this.countDis();
      const data = await getMerchantAudit();
      console.log(data, 'data');
      if (data) {
        if (data.approveStatus === 'fail') {
          this.errBoxShow = true;
          this.errBoxMsg = data.approveComments;
        }
      }
    },
    // 编辑接口
    editForm(item) {
      this.type = 'edit';
      this.popTitle = this.$t('message.jumio.editTitle');
      this.subword = this.$t('message.common.save');

      this.addData.ownerName = shallowClones(item.ownerName);
      if (item.ownerRole === 3) {
        this.addData.ownerRole = ['1', '2'];
      } else {
        this.addData.ownerRole = [String(item.ownerRole)];
      }
      this.Beneficialdis = false;
      this.Directordisabled = false;
      this.addData.id = shallowClones(item.id);
      // console.log(this.addData);
      // this.countDis();
      this.addPop = true;
    },
    // 立即认证
    async immediately(item) {
      // console.log(item);
      const params = {};
      params.id = item.id;
      params.authMethod = 0;
      // console.log('params', params);
      const res = await startAuth(params);
      const url = await QRcode.toDataURL(res.url);
      // this.immediatelyData.url = res.url;
      // console.log('url', url);
      this.immediatelyData.url = url;
      this.immediatelyData.expireTime = res.expireTime;
      this.jumioPop = true;
    },
    // 邮件认证
    async emailAuth(item) {
      const res = await queryEmailSendRecord(item.id);
      if (res) {
        this.emailData.exEmail = res.email;
        this.emailData.sendTime = res.sendTime;
      } else {
        this.emailData.exEmail = '';
        this.emailData.sendTime = '';
      }
      console.log('res', res);
      console.log(item);
      this.emailPop = true;
      this.emailData.ownerName = item.ownerName;
      this.emailData.id = item.id;
      if (item.ownerRole === 3) {
        this.emailData.ownerRole = this.$t('message.user.shareholder') + ',' + this.$t('message.user.beneficiary');
      } else if (item.ownerRole === 1) {
        this.emailData.ownerRole = this.$t('message.user.shareholder');
      } else {
        this.emailData.ownerRole = this.$t('message.user.beneficiary');
      }
    },
    // 新增
    addPopdata() {
      this.addData = {
        ownerName: '',
        ownerRole: [],
      };
      this.type = 'add';
      this.subword = this.$t('message.jumio.add');
      this.addPop = true;
      this.popTitle = this.$t('message.jumio.addTitle');
      this.countDis();
    },
    // 计算编辑框
    countDis() {
      let role1Count = 0;
      let role2Count = 0;
      if (this.jumioData.length > 0) {
        for (let i = 0; i < this.jumioData.length; i++) {
          const item = this.jumioData[i];
          // 根据不同的 ownerRole 值更新计数器
          if (item.ownerRole === 1) {
            role1Count += 1;
          } else if (item.ownerRole === 2) {
            role2Count += 1;
          } else if (item.ownerRole === 3) {
            role1Count += 1;
            role2Count += 1;
          }
          console.log(role1Count, role2Count);
          if (role1Count > 4) {
            this.Directordisabled = true;
          } else {
            this.Directordisabled = false;
          }
          if (role2Count > 4) {
            this.Beneficialdis = true;
          } else {
            this.Beneficialdis = false;
          }
        }
        if (role1Count > 4 && role2Count > 4) {
          this.addShow = false;
        } else {
          this.addShow = true;
        }
      }
      // 遍历数组中的每个对象
    },
    // 关闭弹窗
    closePop() {
      if (this.addPop) {
        this.addPop = false;
      }
      if (this.jumioPop) {
        this.jumioPop = false;
        this.initMethods();
      }
      if (this.emailPop) {
        this.emailPop = false;
        this.emailData.ownerName = '';
        this.emailData.id = '';
        this.emailData.email = '';
        this.initMethods();
      }
    },
    // 添加数据
    async save() {
      try {
        // 使用 await 和 Promise 包装 validate 方法以确保它是异步的
        const valid = await new Promise((resolve) => {
          this.$refs.basicFormRef.validate(resolve);
        });

        if (valid) {
          const params = {
            ownerName: this.addData.ownerName,
          };
          if (Array.isArray(this.addData.ownerRole) && this.addData.ownerRole.length > 1) {
            params.ownerRole = 3;
          } else if (Array.isArray(this.addData.ownerRole) && this.addData.ownerRole.length === 1) {
            params.ownerRole = Number(this.addData.ownerRole[0]);
          } else {
            // throw new Error('Owner role is not selected');
          }
          let res = null;
          if (this.type === 'add') {
            res = await addShareholderInfo(params);
          } else if (this.type === 'edit') {
            const jumioArr = shallowClones(this.jumioData);
            jumioArr.forEach(item => {
              if (item.id === this.addData.id) {
                item.ownerRole = params.ownerRole;
              }
            });
            console.log('jumioArr', jumioArr);
            let role1Count = 0;
            let role2Count = 0;
            if (jumioArr.length > 0) {
              for (let i = 0; i < jumioArr.length; i++) {
                const item = jumioArr[i];
                // 根据不同的 ownerRole 值更新计数器
                if (item.ownerRole === 1) {
                  role1Count += 1;
                } else if (item.ownerRole === 2) {
                  role2Count += 1;
                } else if (item.ownerRole === 3) {
                  role1Count += 1;
                  role2Count += 1;
                }
              }
            }
            console.log(role1Count, role2Count);
            if (role1Count > 5 || role2Count > 5) {
              console.log(role1Count, role2Count);
              ShowErrorMessage(this.$t('message.jumio.addSubTitle'));
              return;
            } else {
              params.id = this.addData.id;
              res = await editShareholderInfo(params);
            }
          }
          if (res) {
            this.initMethods();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      } catch (error) {
        console.error('保存失败:', error);
        // 可以根据需要显示错误信息给用户
      }
    },
    // 取消弹框
    cancel() {
      if (this.addPop) {
        this.addPop = false;
      }
      if (this.emailPop) {
        this.emailPop = false;
      }
    },
    deleJumio(item) {
      console.log('item', item);
      this.$refs.customMessage.openHttpModal({
        titleHtml: this.$t('message.jumio.refuseTitle'),
        contentHtml: this.$t('message.jumio.refuseTips'),
        confirmFuntion: async () => {
          // const params = {
          //   id: item.id,
          // };
          const res = await deleteShareholderInfo(item.id);
          console.log(res);
          if (res === 1) {
            ShowSuccessMessage(this.$t('message.jumio.delSus'));
            this.initMethods();
          }
          // this.$router.push({ path: '/transaction/refuse/appeal', query: { id: data.id } });
        },
      });
    },
    closeItemshow() {
      this.jumioData.map((item, idx) => {
        item.showMore = false;
      });
      this.$forceUpdate();
    },
    async submitAudit() {
      let role1Count = 0;
      let role2Count = 0;
      if (this.jumioData.length > 0) {
        for (let i = 0; i < this.jumioData.length; i++) {
          const item = this.jumioData[i];
          // 根据不同的 ownerRole 值更新计数器
          if (item.ownerRole === 1) {
            role1Count += 1;
          } else if (item.ownerRole === 2) {
            role2Count += 1;
          } else if (item.ownerRole === 3) {
            role1Count += 1;
            role2Count += 1;
          }
        }
      }
      if (this.jumioData.length === 0 || role1Count < 1 || role2Count < 1) {
        ShowErrorMessage(this.$t('message.jumio.atLeast'));
        return;
      }
      for (const item of this.jumioData) {
        if (item.faceAuthStatus === 0) {
          ShowErrorMessage(this.$t('message.jumio.allStauts'));
          return;
        }
      }
      const res = await submitAudit();
      console.log('res', res);
      ShowSuccessMessage(this.$t('message.operateSuccessfulTip'));
      setTimeout(() => {
        this.$router.replace({
          path: '/index',
        });
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/element-variables.scss';

.header {
  // border-bottom: 0.02rem solid #edf1f7;
}

.errBox {
  background: #FFECE8;
  border-radius: 4px 4px 4px 4px;
  padding: 16px;
  box-sizing: border-box;
  margin-top: 32px;
  margin-bottom: 24px;
  display: flex;

  .errImg {
    width: 16px;
    height: 16px;

    img {
      width: 100%;
      height: 100;
    }
  }

  .errTitle {
    font-weight: 600;
    font-size: 14px;
    color: #1A202C;
  }

  .errMes {
    font-size: 14px;
  }
}

.mainContent {
  padding: 16px 0px;
  box-sizing: border-box;
  border-top: 1px solid #EFEFF4;
  border-bottom: 1px solid #EFEFF4;
  margin-top: 16px;
  overflow: hidden;

}

.emailTitle {
  margin-top: 24px;
  font-size: 14px;
  color: #1A202C;
  line-height: 18px;
  font-weight: 600;

}

.emailRole {
  font-weight: 400;
  font-size: 14px;
  color: #667085;
  line-height: 18px;
  margin-top: 4px;
  margin-bottom: 24px;

}

.emailWarn {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background-color: #FFF7E8;
  font-size: 14px;
  color: #1A202C;
  line-height: 16px;
  margin-bottom: 24px;
  display: flex;

  .warnImg {
    width: 15px;
    height: 14px;
    vertical-align: top;

  }

  span {
    margin-left: 8px;
  }
}

.jumioPopContent {
  border-bottom: 0px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 1;

  .jumionContent {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 355px;

    .jumionTitle {
      font-weight: 600;
      font-size: 16px;
      color: #1A202C;
    }

    .jumionTime {
      margin-top: 8px;
      font-size: 14px;
      color: #1A202C;

      .time {
        color: #6655F7 !important
      }
    }

    .jumionTips {
      font-size: 14px;
      color: #667085;
      line-height: 21px;

      .tips {
        width: 16px;
        height: 16px;
        vertical-align: middle;

      }

      .content1 {
        margin-top: 8px;
      }

      .content2 {
        margin-top: 8px;

      }
    }
  }

  .jumionImg {
    flex-basis: 300px;
    height: 300px;
    border-radius: 0px 0px 0px 0px;

    img {
      width: 100%;
      height: 100%;
    }
  }

}

.accountJumio-supplement {
  background: #FBFBFD !important;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.leftTitle {
  margin-right: 32px;
}

.text-wrapper {
  width: 532px;
  margin: 18px auto 0;
  color: $color-text-primary;

  .title {
    font-size: 26px;
    font-weight: 800;
    line-height: 36px;
    text-align: left;
  }

  .tip {
    font-size: 14px;
    font-weight: normal;
    line-height: 24px;
    text-align: center;

    .tip-p {
      text-align: left;
      display: inline-block;
    }
  }
}

.primary-btn {
  padding: 8px 24px;
  background-color: #fff;
  border-radius: 8px 8px 8px 8px;
  border: 0 !important;
  background-color: #503DF6;
  color: #fff;

  &:hover {
    background: #503DF6;
    border: 1px solid $color-primary-purple;
    color: #fff;
  }
}

.add .primary-btn {
  background-color: #fff;
  color: #503DF6;
  margin-top: 24px;
  border: 1px solid #503DF6 !important;

}

.drawer-form {
  width: 532px;
  margin: 0 auto;
  margin-top: 16px;
  // margin-bottom: 110px;

  .jumio-wrapper {
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #EDF1F7;
    padding: 24px;
    box-sizing: border-box;
    margin-bottom: 16px;

    .jumio-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .jumio-name {
        font-weight: bold;
        font-size: 18px;
        color: #1A202C;
        display: -ms-inline-grid;
        display: -moz-inline-grid;
        display: inline-grid;
        max-width: 300px;
        word-break: break-all;
      }

      .status {
        margin-left: 16px;
        font-weight: 400;
        font-size: 12px;
        border-radius: 20px 20px 20px 20px;
        padding: 2px 8px;
        box-sizing: border-box;
      }

      .statusP {
        background: #FFF7E8;
        color: #FF7D00;
      }

      .statusR {
        background: #FFECE8;
        color: #F53F3F;
      }

      .statusA {
        color: #00B42A;
        background: #E8FFEA;
      }

      .statusS {
        color: #503DF6;
        background: #F6F6FF;
      }

      .more {
        color: #667085;
        cursor: pointer;
        width: 26px;
        height: 26px;
        text-align: center;
        // line-height: 26px;
        line-height: 26px;
        border-radius: 8px 8px 8px 8px;
        position: relative;

        .morebox {
          position: absolute;
          top: 30px;
          right: -10px;
          width: 72px;
          background: white;
          text-align: left;
          font-size: 14px;
          color: #667085;
          border-radius: 5px;
          box-shadow: 0 5px 16px rgba(0, 0, 0, 0.05);
          // display: block;

          div {
            height: 38px;
            width: 72px;
            padding-left: 12px;
            line-height: 38px;

            &:hover {
              background-color: #F6F6FF;
              border-radius: 5px;
              box-sizing: border-box;

            }
          }
        }

        &:hover {
          background: #EFEFF4;

          .morebox {
            // display: block;
          }
        }
      }
    }

    .type {
      font-size: 14px;
      color: #667085;
      line-height: 16px;
      margin-top: 12px;
    }

    .time {
      padding-top: 16px;
      box-sizing: border-box;
      border-top: 1px solid #EDF1F7;
      margin-top: 16px;

      .time1 {
        font-size: 14px;
        color: #667085;
      }

      .time2 {
        font-size: 14px;
        color: #1A202C;
        margin-left: 6px;
      }
    }

    .jumio-btn {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;

      div {
        flex-basis: 235px;
        width: 235px;
        font-size: 16px;
        text-align: center;
        padding: 8px 25px;
        box-sizing: border-box;
        border-radius: 8px 8px 8px 8px;
        cursor: pointer;
      }

      .jumio-email {
        border: 1px solid #503DF6;
        color: #503DF6;
      }

      .jumio-im {
        color: #FFFFFF;
        background: #503DF6;

      }
    }
  }
}

.box {
  background: #FBFBFD !important;
  padding-bottom: 20px;
  box-sizing: border-box;
}
</style>
